import * as React from 'react';
import { Callout, DirectionalHint, getTheme, Persona, Stack, Text } from 'office-ui-fabric-react';
import { SubHeading, SubHeadingLevel } from '../Typography/sub-heading';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 *
 * temp for demo
 */
export const Profile = _ref => {
  let {
    user,
    children,
    hideGroups
  } = _ref;
  const [showDetail, setShowDetail] = React.useState(false);
  const personaEl = React.useRef(null);
  const theme = getTheme();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        width: showDetail ? '200px' : '40px'
      },
      ref: personaEl,
      onClick: () => {
        setShowDetail(!showDetail);
      },
      children: /*#__PURE__*/_jsx(Persona, {
        coinSize: 30,
        hidePersonaDetails: !showDetail,
        text: user.Username
      })
    }), showDetail && /*#__PURE__*/_jsxs(Callout, {
      className: "ms-CalloutExample-callout",
      role: "alertdialog",
      gapSpace: 0,
      target: personaEl.current,
      onDismiss: () => setShowDetail(!showDetail),
      setInitialFocus: true,
      directionalHint: DirectionalHint.bottomCenter,
      children: [/*#__PURE__*/_jsxs(Stack, {
        tokens: {
          childrenGap: 10,
          padding: 15
        },
        styles: {
          root: {
            minWidth: '15em'
          }
        },
        children: [/*#__PURE__*/_jsx(Stack, {
          horizontalAlign: "center",
          grow: true,
          tokens: {
            childrenGap: 5,
            padding: '0px 10px 15px 10px'
          },
          styles: {
            root: {
              borderBottom: "solid 1px ".concat(theme.palette.neutralQuaternaryAlt)
            }
          },
          children: /*#__PURE__*/_jsx(SubHeading, {
            headingLevel: SubHeadingLevel.Level1,
            children: user.Username
          })
        }), !hideGroups && (user === null || user === void 0 ? void 0 : user.Groups) && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SubHeading, {
            headingLevel: SubHeadingLevel.Level3,
            children: "Groups"
          }), /*#__PURE__*/_jsx(Stack, {
            children: user.Groups.map(g => {
              return /*#__PURE__*/_jsx(Text, {
                variant: "small",
                children: g
              }, g);
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Stack, {
        tokens: {
          padding: 15
        },
        styles: {
          root: {
            backgroundColor: theme.palette.neutralQuaternary,
            borderTop: "solid 2px ".concat(theme.palette.themePrimary)
          }
        },
        children: children
      })]
    })]
  });
};